export const findAll = (string, substring) => {
  if (!substring) {
    return [];
  }

  const result = [];
  let idx = string.indexOf(substring);
  while (idx !== -1) {
    result.push(idx);
    idx = string.indexOf(substring, idx + 1);
  }
  return result;
};
